import React from 'react';
import { Section } from './ui/Section';
export const UrgencySection = () => {
  const tableData = [{
    solucion: 'Consulta con especialista',
    costo: '$15.000 - $30.000'
  }, {
    solucion: 'Pastillas para dormir (mensual)',
    costo: '$8.000 - $15.000'
  }, {
    solucion: 'Apps de meditación (mensual)',
    costo: '$5.000 - $10.000'
  }, {
    solucion: 'Suplementos y infusiones (mensual)',
    costo: '$5.000 - $12.000'
  }, {
    solucion: 'Este sistema completo',
    costo: '$19.999 una sola vez',
    highlight: true
  }];
  return <Section data-id="element-438">
      <div className="max-w-3xl mx-auto" data-id="element-439">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-440">
          Por qué no tiene sentido esperar
        </h2>

        <h3 className="text-2xl font-bold text-white mb-6" data-id="element-441">
          Calculá el costo de no hacer nada
        </h3>

        <div className="space-y-4 text-lg text-gray-300 mb-16" data-id="element-442">
          <p data-id="element-443">Cada noche que no dormís bien tiene un costo real.</p>
          <ul className="space-y-3 mt-4" data-id="element-444">
            <li data-id="element-445">
              <strong className="text-white" data-id="element-446">En energía:</strong> llegás al día
              siguiente sin recursos para rendir.
            </li>
            <li data-id="element-447">
              <strong className="text-white" data-id="element-448">En salud:</strong> el insomnio
              crónico afecta el sistema inmune, el metabolismo y el estado de
              ánimo.
            </li>
            <li data-id="element-449">
              <strong className="text-white" data-id="element-450">En relaciones:</strong> cuando
              estás agotado sos más irritable, menos paciente, menos presente.
            </li>
            <li data-id="element-451">
              <strong className="text-white" data-id="element-452">En trabajo:</strong> el rendimiento
              cognitivo baja hasta un 40% con falta de sueño.
            </li>
            <li data-id="element-453">
              <strong className="text-white" data-id="element-454">En bienestar:</strong> cada noche
              mal dormida es un día de vida que vivís a media máquina.
            </li>
          </ul>
        </div>

        <h3 className="text-2xl font-bold text-white mb-6" data-id="element-455">
          ¿Cuánto gastaste ya en cosas que no funcionaron?
        </h3>

        <div className="overflow-x-auto pb-4 mb-10" data-id="element-456">
          <table className="w-full text-left border-collapse" data-id="element-457">
            <thead data-id="element-458">
              <tr className="border-b border-night-700" data-id="element-459">
                <th className="py-4 px-6 text-gray-400 font-semibold bg-night-900/50 rounded-tl-lg" data-id="element-460">
                  Solución
                </th>
                <th className="py-4 px-6 text-gray-400 font-semibold bg-night-900/50 rounded-tr-lg" data-id="element-461">
                  Costo aproximado
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-night-700/50" data-id="element-462">
              {tableData.map((row, idx) => <tr key={idx} className={row.highlight ? 'bg-accent-blue/10 border-accent-blue/30' : ''} data-id="element-463">
                  <td className={`py-4 px-6 ${row.highlight ? 'text-white font-bold' : 'text-gray-300'}`} data-id="element-464">
                    {row.solucion}
                  </td>
                  <td className={`py-4 px-6 ${row.highlight ? 'text-cta font-bold' : 'text-gray-400'}`} data-id="element-465">
                    {row.costo}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center space-y-2 text-lg text-gray-300 mb-12" data-id="element-466">
          <p data-id="element-467">Una sola vez.</p>
          <p data-id="element-468">Sin renovación.</p>
          <p data-id="element-469">Sin consultas.</p>
          <p data-id="element-470">Sin efectos secundarios.</p>
        </div>

        <div className="bg-night-800 p-8 rounded-2xl border border-night-700 text-center" data-id="element-471">
          <h4 className="text-xl font-bold text-white mb-4" data-id="element-472">
            La lógica es simple
          </h4>
          <p className="text-lg text-gray-300" data-id="element-473">
            Si estás dispuesto a gastar $15.000 en una consulta que dura 45
            minutos, ¿por qué no invertir $19.999 en un sistema completo que
            podés usar todas las noches para siempre?
          </p>
        </div>
      </div>
    </Section>;
};